//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/excludeVariablesFromRoot.js
var e = (e) => [
	...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`),
	`--${e ? `${e}-` : ""}palette-AppBar-darkBg`,
	`--${e ? `${e}-` : ""}palette-AppBar-darkColor`
];
//#endregion
export { e as default };

//# sourceMappingURL=index101.js.map